import React, { useCallback, useContext } from 'react'
import CommonValueBuildUpTab from '../../../commonComponents/commonValueBuildUpTab'
import { Form } from 'semantic-ui-react'
import ErrorWindowPartiesTab from '../partiesTab/ErrorWindowPartiesTab'
import ActorDetailForm from '../../../commonComponents/formComponents/actorDetailForm'
import { ActorContext } from '../partiesTab/Actors/actorProvider'
import { useDispatch, useSelector } from 'react-redux'
import { updateLineItemFeild } from '../../actions'
import {saveLineItemFeild, createLineItemDuty, removeLineItemDuty} from '../../actions/index'
// import ValuBuildUpProvider from '../../../commonComponents/commonValueBuildUpTab/valuBuildUpProvider'
import { getSum } from '../../../util'
import { useCurrentShipmentType } from '../../../hooks'
import ESVBUProvider from '@commonComponents/commonValueBuildUpTab/ESVBUProvider'

const ValueBuildUpTab = (props) => {
  const dispatch = useDispatch()
  const { isFormDisabled, translate } = props
  const actorDetails = useContext(ActorContext)
  let invoices = useSelector((state) => state.InvoicesReducer.invoices)
  const {totalInvoiceAmount,destinationCountry} = useSelector((state) => state.Shipment)
  const {isImportShipment} = useCurrentShipmentType()

  // for latest changes CORE-13487
  const { buyer, seller } = useSelector(state => state.Actor)

  const actorDetailForm = (params) => {
    return (
      <ErrorWindowPartiesTab params={params} actorType={params.actorType}>
        {(errorInfo) => (
          <ActorDetailForm
            {...params}
            disabled={isFormDisabled}
            {...actorDetails}
            repKey='formOfRepresentation'
            eoriKey='externalIdentification'
            address2='address2'
            countryKey='countryCode'
            errorInfo={errorInfo}
          ></ActorDetailForm>
        )}
      </ErrorWindowPartiesTab>
    )
  }

  const updateFunc = useCallback(
    (...args) => {
      dispatch(updateLineItemFeild(...args))
    },
    [updateLineItemFeild]
  )

  const saveFunc = useCallback(
    (...args) => {
      dispatch(saveLineItemFeild(...args))
    },
    [saveLineItemFeild]
  )

  const createDutyFunc = useCallback(
    (...args) => {
      dispatch(createLineItemDuty(...args))
    },
    [createLineItemDuty]
  )

  const deleteDutyFunc = useCallback(
    (...args) => {
      dispatch(removeLineItemDuty(...args))
    },
    [removeLineItemDuty]
  )

  return (
    <ESVBUProvider
      updateFunc={updateFunc}
      saveFunc={saveFunc}
      invoiceData={invoices}
      createDutyFunc={createDutyFunc}
      deleteDutyFunc={deleteDutyFunc}
      destinationCountry={destinationCountry}
    >
      <div className='formContentareaC88 headerDetails'>
        <Form.Group className='float-container actor'>
          <CommonValueBuildUpTab
            {...props}
            ActorDetailForm={actorDetailForm}
            invoices={invoices}
            invoiceAmount={getSum(invoices, 'merchandiseList')}
            translate={translate}
            isDisabled={isFormDisabled}
            isNLAPP={false}
            isImportShipment={isImportShipment}
            actorDetailsAndActions={actorDetails}
            buyer={buyer}
            seller={seller}
          />
        </Form.Group>
      </div>
    </ESVBUProvider>
  )
}

export default ValueBuildUpTab
